import { render, staticRenderFns } from "./TeacherDetailItem.vue?vue&type=template&id=0d7540b3&scoped=true&"
import script from "./TeacherDetailItem.vue?vue&type=script&lang=js&"
export * from "./TeacherDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetailItem.vue?vue&type=style&index=0&id=0d7540b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7540b3",
  null
  
)

export default component.exports